import { RiskRegisterCardSlotKey } from "src/app/models/risk-register-card.model";

export const RISK_REGISTER_CARD_SLOT_LABELS: Record<RiskRegisterCardSlotKey, string> = {
    main: "Main Value",
    below: "Line Below",
    topRight: "Top Right",
    bottomRight: "Bottom Right",
};
